module.exports = __webpack_public_path__ + "static/media/loading4.474f49e4.gif";